














































































































































































































































































































import {
    computed,
    defineComponent,
    onMounted,
    PropType,
    ref,
    Ref,
} from '@vue/composition-api';
import Vue from 'vue';
import { detailApiApply, getAppInfo, updateCallbackUrl } from '@/apis/controll';
import { ApiInfoStatus, MobileType, Status } from '@/type/enums';
import appSecret from '../app-secret.vue';
import imgUpload from '@/components/img-upload/index.vue';
import entry from '@/components/entry/index.vue';
import drawerPick from './drawerPick.vue';
import scopeMask from './scope-mask.vue';
import { DrawerPickList, MobilePlatVarName, OnStoreOptions } from '../../const';
import { MobileStoreOption } from '../../type';
import { format, checkAndCompleteMobileType } from '../../util';
import {
    getScopeSecurityPng,
    updateMobileBasic,
    updateMobileExtra,
} from '../../service';
import { lowerCaseReg, universalLinkReg, urlReg } from '@/directives/isValid';
import { skipLoadingWrapper } from '@/utils/helper';
import { ZFormRoot } from '@ks/z-form';
import callbackUrl from '../callbackUrl.vue';
import {
    handleSuccessMessageToast,
    handleErrorMessageToast,
} from '@/common/util';
import ConfTable from '@/components/table';
import { columns } from './scope';

export default defineComponent({
    name: 'mobile-detail',
    props: {
        originList: {
            type: Object as PropType<Record<string, any>>,
            required: true,
        },
        apiInfos: {
            type: Array as PropType<Record<string, any>>,
            default: () => {
                return [];
            },
        },
    },
    components: {
        callbackUrl,
        appSecret,
        imgUpload,
        entry,
        drawerPick,
        scopeMask,
        ConfTable,
    },

    setup(props, context) {
        const apiInfoStatus: any = ApiInfoStatus;
        const mobileType: any = MobileType;
        const status = Status;
        const mobilePlatVarName = MobilePlatVarName;
        const isEditBase = ref(false);
        const tipsError = ref(false);
        const isEditOther = ref(false);
        const isBaseEditDisable = ref(false);
        const onStoreOptions: MobileStoreOption[] = [...OnStoreOptions()];
        const drawerPickList: Ref<Array<any>> = ref([]);
        const list: Ref<Record<string, any>> = ref({});
        const isShowMask = ref(false);
        const scopeSecret: Ref<Record<string, any>> = ref({});

        const appId = computed(() => {
            return context.root.$route.params.appId;
        });

        const isShowApiInfo = computed(() => {
            return (
                list.value.status !== status.pending &&
                list.value.status !== status.fail
            );
        });

        const isAppEditDisable = computed(() => {
            return (
                isBaseEditDisable.value || list.value.updateApprovalStatus === 1
            );
        });

        async function handleDetailSelfApiApply(index: number) {
            try {
                const curinfo = props.apiInfos[index];
                const res: any = await detailApiApply(
                    appId.value,
                    curinfo.scopeGroupId,
                );
                if (res.data.result === 1) {
                    context.root.$message({
                        type: 'success',
                        message: '您的申请已提交',
                        customClass: 'message-custom message-success-custom',
                        iconClass: 'message-success-custom-icon',
                    });
                    curinfo.status = apiInfoStatus.applying;
                } else {
                    context.root.$message.error(
                        res.data.error_msg || '请求出错，请重试',
                    );
                }
            } catch (e) {
                context.root.$message.error('服务器错误');
            }
        }
        const detailSelfApiApply = skipLoadingWrapper(handleDetailSelfApiApply);

        function updateDrawerPickList(
            appInfo: any,
            list: any,
            parentNode?: any,
        ) {
            for (let i = 0, len = list.length; i < len; i++) {
                const cur = list[i];

                if (
                    typeof cur.type === 'number' &&
                    ~appInfo.mobileType.indexOf(cur.type)
                ) {
                    cur.selected = true;
                    for (let i = 0, len = cur.fields.length; i < len; i++) {
                        Vue.set(
                            cur.fields[i],
                            'value',
                            appInfo[cur.fields[i].key],
                        );
                    }
                    parentNode && (parentNode.selected = true);
                }
                if (cur.sub && cur.sub.length) {
                    updateDrawerPickList(appInfo, cur.sub, cur);
                }
            }

        }

        const formatDPList = computed(() => {
            return format(drawerPickList.value);
        });
        // eslint-disable-next-line
        const isPlatformInfoValid = computed(() => {
            let res: any;
            let android;
            let ios;
            let ipad;
            let harmony;
            const dpList: any = formatDPList.value;
            const mustType: any[] = [];

            const listLen = dpList.needTypes.length ?? 0;
            for (let i = 0, len = listLen; i < len; i++) {
                dpList.mobileType.forEach((mType: any) => {
                    if (dpList.needTypes[i].includes(mType)) {
                        mustType.push(mType);
                    }
                });
            }

            if (dpList.mobileType.includes(MobileType.android)) {
                android =
                    dpList.androidPackage.trim() && dpList.androidSign.trim();
            }
            if (dpList.mobileType.includes(MobileType.ios)) {
                ios =
                    dpList.iosBundleId.trim() &&
                    dpList.universalLink.trim() &&
                    dpList.iosTestBundleId.trim();
            }
            if (dpList.mobileType.includes(MobileType.ipad)) {
                ipad =
                    dpList.ipadBundleId.trim() &&
                    dpList.ipadTestBundleId.trim() &&
                    dpList.ipadUniversalLink.trim();
            }
            if (dpList.mobileType.includes(MobileType.harmony)) {
                harmony = dpList.harmonyBundleId.trim() && dpList.harmonyIdentifier.trim();
            }
            if (!dpList.needTypes.length) {
                if (dpList.mobileType.length === 1) {
                    return android || harmony
                } else if (dpList.mobileType.length === 2) {
                    return android && harmony
                } else {
                    return android;
                }
            }
            if (dpList.mobileType.includes(MobileType.harmony)) {
                typeof res === 'undefined' ? (res = harmony) : (res = res && harmony);
            }
            if (dpList.mobileType.includes(MobileType.android)) {
                res = res && android;
            }

            if (!mustType.length) {
                return false;
            }
            if (mustType.includes(MobileType.ios)) {
                typeof res === 'undefined' ? (res = ios) : (res = res && ios);
            }
            if (mustType.includes(MobileType.ipad)) {
                typeof res === 'undefined' ? (res = ipad) : (res = res && ipad);
            }

            return res;
        });
        const isValidateUrl = computed(() => {
            const { universalLink, ipadUniversalLink, androidSign } =
                formatDPList.value ?? {};
            return (
                (universalLink
                    ? universalLinkReg.test(universalLink.trim())
                    : true) &&
                (ipadUniversalLink
                    ? universalLinkReg.test(ipadUniversalLink.trim())
                    : true) &&
                (androidSign ? lowerCaseReg.test(androidSign.trim()) : true)
            );
        });

        const canBaseSubmit = computed(() => {
            return (
                list.value.name &&
                list.value.desc &&
                list.value.website &&
                urlReg.test(list.value.website.trim()) &&
                list.value.icon
            );
        });
        const canOtherSubmit = computed(() => {
            return (
                isPlatformInfoValid.value &&
                formatDPList.value.mobileType.length &&
                isValidateUrl.value
            );
        });
        async function refresh() {
            const res: any = await getAppInfo(appId.value);
            if (res.data.result === 1) {
                return checkAndCompleteMobileType(res.data.appInfo);
            }
            context.root.$message({
                type: 'error',
                message: res.data.error_msg || '数据更新失败，请重试',
                customClass: 'message-custom message-error-custom',
                iconClass: 'message-error-custom-icon',
            });
            return {};
        }
        async function cancelEditBase() {
            isEditBase.value = false;
            const refreshInfo = await refresh();
            list.value.name = refreshInfo.name;
            list.value.desc = refreshInfo.desc;
            list.value.website = refreshInfo.website;
            list.value.icon = refreshInfo.icon;
            list.value.onStore = refreshInfo.onStore;
            if (list.value.onStore) {
                onStoreOptions[0].selected = true;
                onStoreOptions[1].selected = false;
            } else {
                onStoreOptions[0].selected = false;
                onStoreOptions[1].selected = true;
            }
        }
        async function cancelEditOther() {
            isEditOther.value = false;
            const refreshInfo = await refresh();
            for (const v of mobilePlatVarName) {
                list.value[v] = refreshInfo[v];
            }
            updateDrawerPickList(list.value, drawerPickList.value);
        }

        async function handleUpdateBase() {
            if (!canBaseSubmit.value) {
                return;
            }
            const res = await updateMobileBasic({
                appId: appId.value,
                name: list.value.name,
                desc: list.value.desc,
                website: list.value.website,
                icon: list.value.icon,
                onStore: list.value.onStore,
            });
            if (res.data.result === 1) {
                context.root.$message({
                    type: 'success',
                    message: '提交审核成功',
                    customClass: 'message-custom message-success-custom',
                    iconClass: 'message-success-custom-icon',
                });
                isBaseEditDisable.value = true;
                isEditBase.value = false;
                return;
            }
            context.root.$message({
                type: 'error',
                message: res.data.error_msg || '提交失败，请重试',
                customClass: 'message-custom message-error-custom',
                iconClass: 'message-error-custom-icon',
            });
        }
        const updateBase = skipLoadingWrapper(handleUpdateBase);
        async function updateOther() {
            !formatDPList.value.mobileType.length
                ? (tipsError.value = true)
                : (tipsError.value = false);
            if (!canOtherSubmit.value) {
                return;
            }

            try {
                await context.root.$confirm(
                    '保存后所配置的信息将立即线上生效，是否确认操作？',
                    '操作提醒',
                    {
                        type: 'warning',
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                    },
                );
            } catch (e) {
                return;
            }

            const res: any = await updateMobileExtra({
                appId: appId.value,
                ...formatDPList.value,
            });
            if (res.data.result === 1) {
                // context.emit('refresh-scope');
                context.root.$message({
                    type: 'success',
                    message: '保存成功', // isSecretUpdate.value ? '修改成功，播放SDK密钥信息已更新' : '保存成功',
                    customClass: 'message-custom message-success-custom',
                    iconClass: 'message-success-custom-icon',
                });
                for (const v of Object.keys(formatDPList.value)) {
                    list.value[v] = formatDPList.value[v];
                }
                isEditOther.value = false;
                return;
            }
            context.root.$message({
                type: 'error',
                message: res.data.error_msg || '保存失败，请重试',
                customClass: 'message-custom message-error-custom',
                iconClass: 'message-error-custom-icon',
            });
        }

        async function goSecurityPng(scopeGroupId: number) {
            try {
                const res: any = await getScopeSecurityPng(
                    appId.value,
                    scopeGroupId,
                );
                if (res.data.result !== 1) {
                    context.root.$message({
                        type: 'error',
                        message: res.data.error_msg || '获取密钥失败，请重试',
                        customClass: 'message-custom message-error-custom',
                        iconClass: 'message-error-custom-icon',
                    });
                    return;
                }
                scopeSecret.value = res.data.data;
                isShowMask.value = true;
            } catch (e) {
                context.root.$message.error('服务器错误');
            }
        }

        const isEditPush = ref(false);
        const pushForm = new ZFormRoot(() => ({
            callbackUrl: '',
            taskId: '',
        }));

        onMounted(() => {
            Object.assign(drawerPickList.value, DrawerPickList());
            list.value = props.originList;
            if (props.originList.onStore) {
                onStoreOptions[0].selected = true;
                onStoreOptions[1].selected = false;
            } else {
                onStoreOptions[0].selected = false;
                onStoreOptions[1].selected = true;
            }
            updateDrawerPickList(list.value, drawerPickList.value);
        });

        onMounted(() => {
            pushForm.initialValue = () => ({
                taskId: '',
                callbackUrl: list.value.callbackUrl,
            });
            pushForm.reset();
        });

        function cancelPushForm() {
            isEditPush.value = false;
            context.root.$nextTick(() => {
                pushForm.reset();
            });
        }
        async function savePushForm() {
            if (!pushForm.canSubmit) return;
            pushForm.validate().then((err) => {
                const { callbackUrl, taskId } = pushForm.value;
                if (err.length === 0) {
                    updateCallbackUrl(callbackUrl, appId.value, taskId)
                        .then((res) => {
                            if (res.data.result !== 1) {
                                handleErrorMessageToast(
                                    res.data.error_msg || '保存失败，请重试',
                                );
                                return;
                            }
                            list.value.callbackUrl = callbackUrl;
                            pushForm.initialValue = () => ({
                                taskId: '',
                                callbackUrl: callbackUrl,
                            });
                            cancelPushForm();
                            handleSuccessMessageToast('保存成功');
                        })
                        .catch(() => {
                            handleErrorMessageToast('服务器错误');
                        });
                }
            });
        }

        return {
            status,
            list,
            isShowApiInfo,
            appId,
            mobileType,
            apiInfoStatus,
            isEditBase,
            isEditOther,
            isAppEditDisable,
            cancelEditBase,
            cancelEditOther,
            canBaseSubmit,
            canOtherSubmit,
            updateBase,
            updateOther,
            onStoreOptions,
            tipsError,
            drawerPickList,
            goSecurityPng,
            isShowMask,
            scopeSecret,
            isEditPush,
            pushForm,
            cancelPushForm,
            savePushForm,
            columns: columns(detailSelfApiApply),
        };
    },
});
